import { ROLE_ICON_NAMES, type RoleIconName } from "../roleIcons";
import type { RoleSettingsUpdateBody } from "../types";

export type RoleIconColour = NonNullable<
  NonNullable<RoleSettingsUpdateBody["icon"]>["colour"]
>;

export const ROLE_EDITOR_ICON_OPTIONS: RoleIconName[] = ROLE_ICON_NAMES;

export const ROLE_EDITOR_COLOR_OPTIONS: RoleIconColour[] = [
  "red",
  "orange",
  "yellow",
  "olive",
  "green",
  "teal",
  "blue",
  "violet",
  "purple",
  "pink",
];
